module.exports = __webpack_public_path__ + "static/media/buzzumo1.413a0fe6.png";